<template>
  <div :class="[bannerPic ? 'bg_image' : 'bg_image_web']" :style="bgStyle">
  
    
    <img :src="'../../static/images/logo_'+this.brandName+'.png'"/>
  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    
    name: 'bannerBg',
    computed: {
      ...mapState([
        'platform',
        'brandName'
      ]),
      bgStyle() {
        return {
          backgroundImage: `url('../../static/images/bg2_${this.brandName}.png')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50%',
          backgroundSize: 'cover'
        }
      }
    },

    data () {
      return {
        bannerPic: this.platform === 'LegendHill'
      }
    }

  }
</script>

<style scoped>
  @import '../assets/css/main.css';
  @import '../assets/css/username.css';
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue